import { create as createStore } from 'zustand';

interface IStore {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useWelcomeModalStore = createStore<IStore>(set => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false })
}));
